var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"playback-request-button h-full",on:{"click":_vm.onClick}},[_c('date-time-setting-icon',{staticClass:"playback-request-button-icon"}),_c('span',{staticClass:"playback-request-button-text aisea-text-14-400-black"},[_vm._v("\n    "+_vm._s(_vm.text)+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }